import { Department } from '@app/models/department';
import { Action } from '@ngrx/store';

interface DepartmentCreationData {
    name: string;
    level: number;
    ParentId: number;
}

export enum DepartmentActionTypes {
    Load = '[API] Load Departments',
    LoadSuccess = '[API] Load Departments Success',
    LoadFail = '[API] Load Departments Fail',

    // LoadCalculated = '[API] Load Departments Cal',
    // LoadCalculatedSuccess = '[API] Load Departments Cal Success',
    // LoadCalculatedFail = '[API] Load Departments Cal Fail',

    LoadByConditions = '[API] Load by conditions Departments',
    LoadByConditionsSuccess = '[API] Load by conditions Departments Success',
    LoadByConditionsFail = '[API] Load by conditions Departments Fail',

    Create = '[API] Create Department',
    CreateSuccess = '[API] Create Department Success',
    CreateFail = '[API] Create Department Fail',

    Select = '[Department] Select',

    Search = '[Search] Search department',
    SearchSuccess = '[Search] Search department success',
    SearchFail = '[Search] Search department fail',
    ClearSearch = '[Search] Clear search department',

    Clear = '[Search] Clear department',

    Update = '[Department] Update department',
    UpdateSuccess = '[Department] Update department success',
    UpdateFail = '[Department] Update department fail',

    Delete = '[Department] Delete department',
    DeleteSuccess = '[Department] Delete department success',
    DeleteFail = '[Delete] Delete department fail',

    LoadById = '[API] Load by Id Department',
    LoadByIdSuccess = '[API] Load by Id Department success',
    LoadByIdFail = '[API] Load by Id Department fail',

    Void = '[VOID] Void action that should not be handled',

    updateHierarchyPlanner ='[Department] update hierarchy planner',
    updateHierarchyPlannerSuccess ='[Department] update hierarchy planner success',
    updateHierarchyPlannerFail ='[Department] update hierarchy planner fail',

    Download = '[Department] download department sheets',
    DownloadSuccess = '[Department] download department sheets success',
    DownloadFail = '[Department] download department sheets fail',

    Upload = '[Department] Upload department sheets',
    UploadSuccess = '[Department] Upload department sheets success',
    UploadFail = '[Department] Upload department sheets fail',

    UploadLink = '[Department] UploadLink',
    UploadLinkSuccess = '[Department] UploadLink success',
    UploadLinkFail = '[Department] UploadLink fail',

    UploadProcessUpdate = '[Department] upload department file process update',
    UploadProcessUpdateAccept = '[Department] upload department file process update accept',
    UploadProcessSuccess = '[Department] upload department file process success',
    UploadProcessFail = '[Department] upload department file process fail',
}

export class Load implements Action {
    readonly type = DepartmentActionTypes.Load;
    constructor() { }
}

export class LoadSuccess implements Action {
    readonly type = DepartmentActionTypes.LoadSuccess;
    constructor(public departments: Department[]) { }
}

export class LoadFail implements Action {
    readonly type = DepartmentActionTypes.LoadFail;
    constructor(public error: any) { }
}

export class Download implements Action {
    readonly type = DepartmentActionTypes.Download;
    constructor(public departmentId: number) { }
}

export class DownloadSuccess implements Action {
    readonly type = DepartmentActionTypes.DownloadSuccess;
    constructor(public data?: any) { }
}

export class DownloadFail implements Action {
    readonly type = DepartmentActionTypes.DownloadFail;
    constructor(public error?: any) { }
}

export class Upload implements Action {
    readonly type = DepartmentActionTypes.Upload;
    constructor(public file: any, public departmentId: number, public upsertType: any) {}
}

export class UploadSuccess implements Action {
    readonly type = DepartmentActionTypes.UploadSuccess;
    constructor(public data?: any) {}
}

export class UploadFail implements Action {
    readonly type = DepartmentActionTypes.UploadFail;
    constructor(public error?: any) {}
}

export class UploadLink implements Action {
    readonly type = DepartmentActionTypes.UploadLink;
    constructor(
      public uploadUrl: string,
      public FileId: number,
      public file: any,
      public upsertType?: any
    ) {}
}

export class UploadLinkSuccess implements Action {
    readonly type = DepartmentActionTypes.UploadLinkSuccess;
    constructor(public FileId?: number, public upsertType?: any) {}
}

export class UploadLinkFail implements Action {
    readonly type = DepartmentActionTypes.UploadLinkFail;
    constructor(public error?: any) {}
}

export class UploadProcessUpdate implements Action {
    readonly type = DepartmentActionTypes.UploadProcessUpdate;
    constructor(public data: any) {}
}

export class UploadProcessUpdateAccept implements Action {
    readonly type = DepartmentActionTypes.UploadProcessUpdateAccept;
    constructor(public data?: any) {}
}

export class UploadProcessSuccess implements Action {
    readonly type = DepartmentActionTypes.UploadProcessSuccess;
    constructor(public data?: any) {}
}

export class UploadProcessFail implements Action {
    readonly type = DepartmentActionTypes.UploadProcessFail;
    constructor(public error: any) {}
}

// export class LoadCalculated implements Action {
//   readonly type = DepartmentActionTypes.LoadCalculated;
//   constructor(public FollowId: any) {}
// }

// export class LoadCalculatedSuccess implements Action {
//   readonly type = DepartmentActionTypes.LoadCalculatedSuccess;
//   constructor(public departments: Department[]) {}
// }

// export class LoadCalculatedFail implements Action {
//   readonly type = DepartmentActionTypes.LoadCalculatedFail;
//   constructor(public error: any) {}
// }

export class LoadByConditions implements Action {
    readonly type = DepartmentActionTypes.LoadByConditions;
    constructor(public FollowId: number, public dataConditions?: any) { }
}

export class LoadByConditionsSuccess implements Action {
    readonly type = DepartmentActionTypes.LoadByConditionsSuccess;
    constructor(public departments: Department[]) { }
}

export class LoadByConditionsFail implements Action {
    readonly type = DepartmentActionTypes.LoadByConditionsFail;
    constructor(public error: any) { }
}

export class Create implements Action {
    readonly type = DepartmentActionTypes.Create;
    constructor(public data: DepartmentCreationData) { }
}

export class CreateSuccess implements Action {
    readonly type = DepartmentActionTypes.CreateSuccess;
    constructor(public department: Department) { }
}

export class CreateFail implements Action {
    readonly type = DepartmentActionTypes.CreateFail;
    constructor(public error: any) { }
}

export class Select implements Action {
    readonly type = DepartmentActionTypes.Select;
    constructor(public id: number) { }
}

export class Search implements Action {
    readonly type = DepartmentActionTypes.Search;
    constructor(public data: any, public FollowId: any) { }
}

export class SearchSuccess implements Action {
    readonly type = DepartmentActionTypes.SearchSuccess;
    constructor(public DepartmentIds: number[]) { }
}

export class SearchFail implements Action {
    readonly type = DepartmentActionTypes.SearchFail;
    constructor(public error: any) { }
}

export class ClearSearch implements Action {
    readonly type = DepartmentActionTypes.ClearSearch;
    constructor() { }
}

export class Clear implements Action {
    readonly type = DepartmentActionTypes.Clear;
    constructor() { }
}

export class Update implements Action {
    readonly type = DepartmentActionTypes.Update;
    constructor(public id: number, public department: any) { }
}
export class UpdateFail implements Action {
    readonly type = DepartmentActionTypes.UpdateFail;
    constructor(public error: any) { }
}

export class UpdateSuccess implements Action {
    readonly type = DepartmentActionTypes.UpdateSuccess;
    constructor(public id: number, public department: any) { }
}

export class Delete implements Action {
    readonly type = DepartmentActionTypes.Delete;
    constructor(public id: number) { }
}
export class DeleteFail implements Action {
    readonly type = DepartmentActionTypes.DeleteFail;
    constructor(public error: any) { }
}

export class DeleteSuccess implements Action {
    readonly type = DepartmentActionTypes.DeleteSuccess;
    constructor(public DepartmentId: any) { }
}

export class Void implements Action {
    readonly type = DepartmentActionTypes.Void;
    constructor() { }
}


export class LoadById implements Action {
    readonly type = DepartmentActionTypes.LoadById;
    constructor(public FollowId: number, public dataFilter?: any) { }
}

export class LoadByIdSuccess implements Action {
    readonly type = DepartmentActionTypes.LoadByIdSuccess;
    constructor(public CategoryId: any, public data: any) { }
}

export class LoadByIdFail implements Action {
    readonly type = DepartmentActionTypes.LoadByIdFail;
    constructor(public error: any) { }
}

export class updateHierarchyPlanner implements Action {
    readonly type = DepartmentActionTypes.updateHierarchyPlanner;
    constructor(){}
}

export class updateHierarchyPlannerSuccess implements Action {
    readonly type = DepartmentActionTypes.updateHierarchyPlannerSuccess;
    constructor(public data?: any){}
}

export class updateHierarchyPlannerFail implements Action {
    readonly type = DepartmentActionTypes.updateHierarchyPlannerFail;
    constructor(public error?: any){}
}

export type DepartmentActionsUnion =
    | Load
    | LoadSuccess
    | LoadFail
    | LoadByConditions
    | LoadByConditionsSuccess
    | LoadByConditionsFail
    | Create
    | CreateSuccess
    | CreateFail
    | Select
    | Search
    | SearchSuccess
    | SearchFail
    | ClearSearch
    | Clear
    | Update
    | UpdateSuccess
    | UpdateFail
    | Delete
    | DeleteSuccess
    | DeleteFail
    | LoadById
    | LoadByIdSuccess
    | LoadByIdFail
    | Void
    | updateHierarchyPlanner
    | updateHierarchyPlannerSuccess
    | updateHierarchyPlannerFail
    | Download
    | DownloadSuccess
    | DownloadFail
    | Upload
    | UploadSuccess
    | UploadFail
    | UploadLink
    | UploadLinkSuccess
    | UploadLinkFail
    | UploadProcessUpdate
    | UploadProcessUpdateAccept
    | UploadProcessSuccess
    | UploadProcessFail;
